<template>

    <div class="h5 bg-white h-100">

        <!-- Mobile back button -->
        <div class="dn-m dn-l ph3 pv3 bb b--light-gray">
            <BackLink @click="$emit('backClick')">Back to Menu</BackLink>
        </div>

        <SignupCore/>

        <!-- Login option -->
        <div class="tc">
            <div class="mt4">Already have an account?</div>
            <a class="link black pointer" @click="$emit('loginClick')"><h5 class="yellow mt1 mb3 grow">Log in</h5></a>
        </div>

    </div>

</template>

<script>
import BackLink from '@/components/controls/BackLink.vue';
import SignupCore from '@/components/global/SignupCore.vue';

export default {
    components: {
        BackLink,
        SignupCore
    }
};
</script>
